// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loader_container__QClwY {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(10px);
}

.Loader_loaderBox__hgxCB {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
}

.Loader_logo__DHuPR {
  width: min(250px, 40vw);
  height: auto;
  overflow: visible;
}

.Loader_mark__kAMWC {
  transform-box: fill-box;
  transform-origin: center;
  animation: Loader_markFloat__PiDuf 1.8s ease-in-out infinite;
}

.Loader_word__J4uWq {
  fill: #104093;
}

.Loader_letter__ZdbXg {
  fill: #104093;
  opacity: 0;
  animation: Loader_letterFade__9eErR 1.5s ease-in-out infinite;
}

.Loader_ticketDots__jGq8d {
  animation: Loader_dotsPulse__RL9Wq 1.2s ease-in-out infinite;
}

.Loader_loaderStar__OZh3d {
  transform-box: fill-box;
  transform-origin: center;
  animation: Loader_loaderStarPop__1znuF 1.2s ease-in-out infinite;
}

.Loader_loaderSparks__07sJu {
  transform-box: fill-box;
  transform-origin: center;
  animation: Loader_loaderSparksPop__hMBvU 1.2s ease-in-out infinite;
}

.Loader_loadingText__M8q2k {
  color: #104093;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  animation: Loader_textPulse__bVsY9 1.2s ease-in-out infinite;
}

@keyframes Loader_markFloat__PiDuf {
  0%, 100% {
    transform: translateY(0) scale(1);
  }
  50% {
    transform: translateY(-4px) scale(1.015);
  }
}
@keyframes Loader_letterFade__9eErR {
  0%, 100% {
    opacity: 0.45;
  }
  50% {
    opacity: 1;
  }
}
@keyframes Loader_dotsPulse__RL9Wq {
  0%, 100% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
}
@keyframes Loader_loaderStarPop__1znuF {
  0%, 100% {
    transform: scale(1) rotate(0deg);
  }
  50% {
    transform: scale(1.12) rotate(5deg);
  }
}
@keyframes Loader_loaderSparksPop__hMBvU {
  0%, 100% {
    opacity: 0.6;
    transform: scale(0.94);
  }
  50% {
    opacity: 1;
    transform: scale(1.08);
  }
}
@keyframes Loader_textPulse__bVsY9 {
  0%, 100% {
    opacity: 0.55;
  }
  50% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Loader/Loader.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qCAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,uBAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,uBAAA;EACA,wBAAA;EACA,4DAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,UAAA;EACA,6DAAA;AACF;;AAEA;EACE,4DAAA;AACF;;AAEA;EACE,uBAAA;EACA,wBAAA;EACA,gEAAA;AACF;;AAEA;EACE,uBAAA;EACA,wBAAA;EACA,kEAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,4DAAA;AACF;;AAEA;EAEE;IAEE,iCAAA;EADF;EAIA;IACE,wCAAA;EAFF;AACF;AAKA;EAEE;IAEE,aAAA;EALF;EAQA;IACE,UAAA;EANF;AACF;AASA;EAEE;IAEE,YAAA;EATF;EAYA;IACE,UAAA;EAVF;AACF;AAaA;EAEE;IAEE,gCAAA;EAbF;EAgBA;IACE,mCAAA;EAdF;AACF;AAiBA;EAEE;IAEE,YAAA;IACA,sBAAA;EAjBF;EAoBA;IACE,UAAA;IACA,sBAAA;EAlBF;AACF;AAqBA;EAEE;IAEE,aAAA;EArBF;EAwBA;IACE,UAAA;EAtBF;AACF","sourcesContent":[".container {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.82);\n  backdrop-filter: blur(10px);\n}\n\n.loaderBox {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1.25rem;\n}\n\n.logo {\n  width: min(250px, 40vw);\n  height: auto;\n  overflow: visible;\n}\n\n.mark {\n  transform-box: fill-box;\n  transform-origin: center;\n  animation: markFloat 1.8s ease-in-out infinite;\n}\n\n.word {\n  fill: #104093;\n}\n\n.letter {\n  fill: #104093;\n  opacity: 0;\n  animation: letterFade 1.5s ease-in-out infinite;\n}\n\n.ticketDots {\n  animation: dotsPulse 1.2s ease-in-out infinite;\n}\n\n.loaderStar {\n  transform-box: fill-box;\n  transform-origin: center;\n  animation: loaderStarPop 1.2s ease-in-out infinite;\n}\n\n.loaderSparks {\n  transform-box: fill-box;\n  transform-origin: center;\n  animation: loaderSparksPop 1.2s ease-in-out infinite;\n}\n\n.loadingText {\n  color: #104093;\n  font-size: 1rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  animation: textPulse 1.2s ease-in-out infinite;\n}\n\n@keyframes markFloat {\n\n  0%,\n  100% {\n    transform: translateY(0) scale(1);\n  }\n\n  50% {\n    transform: translateY(-4px) scale(1.015);\n  }\n}\n\n@keyframes letterFade {\n\n  0%,\n  100% {\n    opacity: 0.45;\n  }\n\n  50% {\n    opacity: 1;\n  }\n}\n\n@keyframes dotsPulse {\n\n  0%,\n  100% {\n    opacity: 0.7;\n  }\n\n  50% {\n    opacity: 1;\n  }\n}\n\n@keyframes loaderStarPop {\n\n  0%,\n  100% {\n    transform: scale(1) rotate(0deg);\n  }\n\n  50% {\n    transform: scale(1.12) rotate(5deg);\n  }\n}\n\n@keyframes loaderSparksPop {\n\n  0%,\n  100% {\n    opacity: 0.6;\n    transform: scale(0.94);\n  }\n\n  50% {\n    opacity: 1;\n    transform: scale(1.08);\n  }\n}\n\n@keyframes textPulse {\n\n  0%,\n  100% {\n    opacity: 0.55;\n  }\n\n  50% {\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Loader_container__QClwY`,
	"loaderBox": `Loader_loaderBox__hgxCB`,
	"logo": `Loader_logo__DHuPR`,
	"mark": `Loader_mark__kAMWC`,
	"markFloat": `Loader_markFloat__PiDuf`,
	"word": `Loader_word__J4uWq`,
	"letter": `Loader_letter__ZdbXg`,
	"letterFade": `Loader_letterFade__9eErR`,
	"ticketDots": `Loader_ticketDots__jGq8d`,
	"dotsPulse": `Loader_dotsPulse__RL9Wq`,
	"loaderStar": `Loader_loaderStar__OZh3d`,
	"loaderStarPop": `Loader_loaderStarPop__1znuF`,
	"loaderSparks": `Loader_loaderSparks__07sJu`,
	"loaderSparksPop": `Loader_loaderSparksPop__hMBvU`,
	"loadingText": `Loader_loadingText__M8q2k`,
	"textPulse": `Loader_textPulse__bVsY9`
};
export default ___CSS_LOADER_EXPORT___;
